import {filterByPermissions} from './helpers';
import {paths} from '../../dictionaries/urls';
import {resources, scopes} from '../../permissions/dictionary';

const commercialUsers = [{
  'name': 'Usuarios',
  'path': paths.CommercialUsers,
  'resource': resources.CommercialUsers,
  'scopes': [scopes.See, scopes.Edit],
  'icon': 'order',
}];

const getCommercialEnterOptions = (permissions) => {
  const options = [{
    'name': 'Mantenimiento',
    'options': filterByPermissions(permissions, commercialUsers),
  }];
  
  return options.filter((item) => item.options.length);
};

export const getCommercialOptions = (permissions) => {
  const options = [
    {
      'name': 'Entrada',
      'options': getCommercialEnterOptions(permissions),
    },
  ];
  
  return options.filter((item) => item.options.length);
};

export const commercialOptions = [
  ...commercialUsers,
];
